import { Configuration, LogLevel } from '@azure/msal-browser';

export const NAA_REDIRECT_URI = 'brk-multihub://outlook-add-in.deskare.io';
export const BROWSER_REDIRECT_URI_FALLBACK = 'https://outlook-add-in.deskare.io';

export function getClientId(): string {
  const clientId = process.env.VITE_AZURE_CLIENT_ID;
  if (!clientId) {
    throw new Error(
      'AZURE_CLIENT_ID environment variable is required for NAA authentication.'
    );
  }
  return clientId;
}

export function getApiScopes(): string[] {
  const clientId = getClientId();
  return [
    `api://${clientId}/access_as_user`,
    'openid',
    'profile',
    'User.Read',
  ];
}

export function getBrowserRedirectUri(): string {
  if (typeof window === 'undefined') return BROWSER_REDIRECT_URI_FALLBACK;
  const origin = window.location.origin;
  return origin || BROWSER_REDIRECT_URI_FALLBACK;
}

export type MsalMode = 'naa' | 'browser';

export function getMsalConfig(mode: MsalMode): Configuration {
  const clientId = getClientId();
  const isNaa = mode === 'naa';

  return {
    auth: {
      clientId,
      authority: 'https://login.microsoftonline.com/common',
      redirectUri: isNaa ? NAA_REDIRECT_URI : getBrowserRedirectUri(),
      navigateToLoginRequestUrl: false,
      supportsNestedAppAuth: isNaa,
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: false,
    },
    system: {
      loggerOptions: {
        logLevel: LogLevel.Warning,
        loggerCallback: (level, message, containsPii) => {
          if (containsPii) return;
          switch (level) {
            case LogLevel.Error:
              console.error('[MSAL]', message);
              break;
            case LogLevel.Warning:
              console.warn('[MSAL]', message);
              break;
            case LogLevel.Info:
              console.info('[MSAL]', message);
              break;
            case LogLevel.Verbose:
              console.debug('[MSAL]', message);
              break;
          }
        },
      },
      windowHashTimeout: 60000,
      iframeHashTimeout: 60000,
      loadFrameTimeout: 30000,
      navigateFrameWait: 0,
    },
  };
}

